import { VDialog } from 'vuetify/lib'

/**
 * @file DDv2用ダイアログ
 * @namespace components
 */

/**
 * @see https://vuetifyjs.com/ja/api/v-dialog/
 */
export default VDialog.extend({
  name: 'DdDialog'
})
